import { Tooltip } from '@mui/material';
import React from 'react';

/**
 * Props for the PermissionTooltip component.
 */
interface Props {
  /**
   * Whether the tooltip should be shown or not.
   * If true, the tooltip appears on hover with the message.
   */
  show: boolean;

  /**
   * Optional custom message to display in the tooltip.
   * Defaults to "You are not authorized to perform this action."
   */
  message?: string;

  /**
   * A single React element that will be wrapped by the tooltip.
   * This must be a valid ReactElement (not a string, fragment, or array).
   */
  children: React.ReactElement;
}

/**
 * `PermissionTooltip` is a wrapper component that displays
 * an authorization message in a tooltip when the user is not allowed
 * to interact with the wrapped element.
 *
 * It does not interfere with click/disabled logic — it is purely visual.
 *
 */
const PermissionTooltip = ({
  show,
  message = 'You are not authorized to perform this action.',
  children,
}: Props) => {
  return (
    <Tooltip
      title={show ? message : ''}
      arrow
      disableHoverListener={!show}
      placement="bottom"
    >
      {/* span ensures Tooltip works even if child is a custom component */}
      <span style={{ display: 'inline-block' }}>{children}</span>
    </Tooltip>
  );
};

export default PermissionTooltip;
